import React from 'react';
import '../App.css';
import './services1.css';
import './fullstack.css';
import SEO from '../SEO';
import PopUp_Divs from './popup_divs.js'
import Purple_Galaxy from '../images/purple_galaxy_web.mp4'; 
import { GrOptimize } from "react-icons/gr";
import { FaUserCog } from "react-icons/fa";
import { PiLockKeyFill } from "react-icons/pi";
import Link from '../images/broken_link2.gif';
import Grow from '../images/growth2.gif';
import Hands from '../images/strategic_alliance2.gif';
//import Seo from '../images/seo2.gif';
//import Website from '../images/webpage-list2.gif';
//import Boss from '../images/boss2.gif';
import { useScrollBehavior } from './useScrollBehavior.js'; 
import Footer from './footer.js' 


const FullStack = () => {

    useScrollBehavior();

	const title = "Full-Stack Digital Solutions | Yokai Software";
	const description = "Yokai Software delivers full-stack digital solutions with custom frontend development, scalable backend systems, secure integrations, and performance-focused architecture.";
	const canonical = "https://yokaisoftware.com/fullstack";
	const image = "https://yokaisoftware.com/yokai_apple_touch_icon2.png";

	const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://yokaisoftware.com/#organization",
      name: "Yokai Software",
      url: "https://yokaisoftware.com/",
      logo: "https://yokaisoftware.com/yokai_apple_touch_icon2.png",
      description:
        "Yokai Software provides web design, web development, SEO, app development, and full-stack digital solutions for businesses."
    },
    {
      "@type": "Service",
      "@id": "https://yokaisoftware.com/fullstack#service",
      serviceType: "Full-Stack Digital Solutions",
      name: "Full-Stack Digital Solutions",
      provider: {
        "@id": "https://yokaisoftware.com/#organization"
      },
      url: "https://yokaisoftware.com/fullstack",
      description:
        "Custom full-stack digital solutions built with modern frontend development, secure backend systems, scalable architecture, and cloud-ready infrastructure."
    },
    {
      "@type": "WebPage",
      "@id": "https://yokaisoftware.com/fullstack#webpage",
      url: "https://yokaisoftware.com/fullstack",
      name: "Full-Stack Digital Solutions | Yokai Software",
      description:
        "Yokai Software delivers full-stack digital solutions with custom frontend development, scalable backend systems, secure integrations, and performance-focused architecture.",
      isPartOf: {
        "@id": "https://yokaisoftware.com/#website"
      },
      about: {
        "@id": "https://yokaisoftware.com/fullstack#service"
      }
    }
  ]
};
    
	const ROUTES = {
	  "Learn More": "/about",
	  "Contact Us": "/ContactPage",
	  "See Plans": "/about",
	  "Get Support": "/ContactPage",
	  "View Case Studies": "/portfolio",
	  "Get a Free Quote": "/ContactPage",
	};
	
	React.useEffect(() => {
	  const handler = (e) => {
		
		const el = e.target.closest('button, a, [role="button"], .btn, .button, .my-button-class, [data-button]');
		if (!el) return;
	
		const label = (el.textContent || "").trim();
		const path = ROUTES[label];
		if (!path) return;           
		 sessionStorage.removeItem('scrollPosition');
	   
		window.scrollTo(0, 0);
	
		e.preventDefault();          
		window.location.assign(path); 
	  };
	  
	  document.addEventListener('click', handler, true);
	  return () => document.removeEventListener('click', handler, true);
	}, []);
	

	return (
		<div id='services_div1'>
			<SEO
      			title={title}
      			description={description}
      			canonical={canonical}
      			image={image}
      			schema={schema}
    		/>
			<div className='module_service' id='service_moduleOne'>
				<video  autoPlay muted loop playsInline preload="auto" crossorigin="anonymous" fetchpriority="high">
					<source src={Purple_Galaxy} type="video/mp4" fetchpriority="high"/>
						Your browser does not support the video tag.
				</video>
				<div id='services_heading1'><h1>Full-Stack Digital Solutions</h1></div>
			</div>
            <div className='module_service' id='service_moduleTwo'>
				<div id='service_mod2_container'>
					<div id='service_mod2_inner1'>
						<h1 id='service_about_h1'>Your Business Deserves More Than Just Code</h1>
						<h2>Complete Frontend + Backend Solutions, Built to Scale.</h2>
					</div>
					<div id='service_mod2_inner2'>
						<p>A beautiful interface without a strong backend falls short — and a powerful 
                            backend without a great user experience leaves customers frustrated. That's 
                            why full stack development is essential. Your applications must be both 
                            visually engaging and technically reliable, combining seamless design with 
                            scalable infrastructure.
                            <br></br>
                            <br></br>
                            The digital landscape is more demanding than ever, and businesses that 
                            invest in complete, end-to-end development have the clear advantage. 
                            Without it, even the most promising ideas can be slowed by poor 
                            performance, security gaps, or lack of integration.
                            <br></br>
                            <br></br>
                            At <strong>Yokai Software</strong>, we help startups, small businesses, and growing brands 
                            with full stack solutions tailored to their goals. From modern, responsive 
                            frontends built in React to secure, scalable backends powered by Node.js 
                            and Express, we deliver everything under one roof. Whether it's a simple 
                            app, a complex platform, or a system that integrates with cloud services 
                            like AWS, our focus is on delivering reliability, performance, and 
                            long-term growth.</p>
					</div>
				</div>

			</div>
             <div className='module_service' id='service_moduleTwo'>
                <PopUp_Divs
				pageKey="fullstack"
                data={[
                    { 
						buttons: ["Learn More", "Contact Us"], 
                        h2: "Unified Development", 
                        p: "Frontend and Backend, Seamlessly Connected. One partner handles the entire stack, so your project runs smoother, faster, and with less hassle." 
                    },
                    { 
						buttons: ["See Plans", "Get Support"],
                        h2: "Scalable & Reliable", 
                        p: "Built to Grow With Your Business. From the first line of code to cloud deployment, your app is designed to scale without breaking down." 
                    },
                    { 
						buttons: ["View Case Studies"],
                        h2: "End-to-End Expertise", 
                        p: "Complete Solutions, One Team. We cover design, development, databases, and deployment — no need to juggle multiple providers." 
                    }
                  ]}
                />
             </div>
			 <div className='module_service' id='service_moduleThree'>
				<div id='service_mod2_container2_fullstack'>
					<div className="conversion-module">
						<div id='conversion-module_subdiv'>
				  			<h2>Performance-Driven Full Stack Development</h2>

  						<p>
    						Full stack development is about more than connecting a frontend 
                            to a backend — it's about creating seamless, scalable systems that 
                            work as hard as your business does. At Yokai Software, we deliver 
                            complete solutions that combine user-friendly interfaces with powerful, 
                            secure server-side functionality. By handling every layer of the stack, 
                            we ensure your applications are fast, reliable, and ready to grow alongside 
                            your goals
  						</p>
						</div>

  				<div className="conversion-funnel">
    				<div className="step"><GrOptimize className="icon"/><strong>Optimize:</strong>Clean, efficient code across both frontend and backend ensures your applications run fast, stay secure, and scale easily as your business grows.</div>
    				<div className="step"><FaUserCog className="icon"/><strong>Engage:</strong> Seamless user interfaces powered by reliable server-side logic create smooth experiences that connect directly with your customers, no matter the platform.</div>
    				<div className="step"><PiLockKeyFill className="icon"/><strong>Retain:</strong> Continuous monitoring, backend updates, and infrastructure improvements guarantee your full stack systems remain stable, secure, and future-ready.</div>
  				</div>

  				<ul className="conversion-points">
                    <h2>What You Get With Full-Stack Development</h2>
    				    <li>Optimized Performance — Clean, efficient code across frontend and backend for speed and stability.</li>
    				    <li>Seamless Integration — User interfaces and server logic working together as one system.</li>
    				    <li>Scalability — Infrastructure designed to expand effortlessly as your business grows.</li>
                        <li>Security First — Strong authentication, data protection, and backend safeguards.</li>
    				    <li>End-to-End Expertise — One partner managing every layer of development, from database to design.</li>
  				</ul>

  				<div className="conversion-ctas">
    				<div href="/ContactPage" id='btn-primary' className="btn">Get a Free Quote</div>
    				<div href="/portfolio" id='btn_service' className="btn">View Case Studies</div>
  				</div>
				</div>
				</div>
			 </div>
			<div className='module_service' id='service_moduleFour'>
				<div id='mod4_div2_service'>
					<div id='mod4_div2_service_heading_fullstack'>
				  		<h1>What Choosing Yokai Software for Your Full-Stack development Means for You</h1>
						
					</div>
					<div id='mod4_sub_div_container_service'>
						<div className='mod4_sub_div_service'>		
				  				<div id='mod4_Sub_div_icon1_service'>
									<img src={Link} alt="Link icon" className="plan" />
								</div>
								<h2>Complete End-to-End Solutions</h2>
								<p>We handle every layer of development — frontend, backend, databases, and deployment — so you don't have to juggle multiple teams or vendors.</p>
						</div>
						<div className='mod4_sub_div_service'>
				  				<div id='mod4_Sub_div_icon2_service'>
				  					<img src={Grow} alt="Grow icon" className="sales" />
								</div>		
								<h2>Future-Ready Scalability</h2>
								<p>Our full stack solutions are built to grow with you, ensuring your systems can handle increased users, new features, and evolving business needs without costly rebuilds.</p>
						</div>
						<div className='mod4_sub_div_service'>
							<div id='mod4_Sub_div_icon3_service'>
								<img src={Hands} alt="Hands icon" className="business" />
							</div>
							<h2>Transparent Partnership</h2>
							<p>We don't hide behind jargon or “black box” processes. You'll always know what we're building, why it matters, and how it impacts your business goals.</p>
						</div>
						
					</div>

				</div>				
			</div>
			<Footer/>
			
		</div>
	);
};

export default FullStack;